<template>
  <div id="order-process" class="order-process" v-if="route !== '/cart'">
    <transition :name="currentTransition" mode="in-out">
      <component :is="currentComponent" :cart-items="allCartItems"></component>
    </transition>
    <transition :name="currentTransition" mode="in-out">
      <div
        class="order-process__cart"
        v-if="currentComponent === 'CartItemList'"
      >
        <div class="order-process__actions">
          <CreateNewPrintItemButton>
            <SvgIcon
              icon="icon--web-application_add"
              class="is-primary-dark"
            ></SvgIcon>
            {{ $t("checkout.upload.chooseDifferent3DFile") }}
          </CreateNewPrintItemButton>
          <a @click="goToCart()" class="button is-primary-dark px-6">
            {{$t("checkout.nextStep")}}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Configure3DModel from "./Configure3DModel";
import CartItemList from "./CartItemList";
import FileUpload from "./FileUpload";
import { orderProcess } from "../../store/constants/order-process";
import CreateNewPrintItemButton from "./CreateNewPrintItemButton";
import SvgIcon from "../svg/SvgIcon";
import { mapGetters } from "vuex";

export default {
  name: "OrderProcess",
  components: {
    FileUpload,
    CartItemList,
    Configure3DModel,
    CreateNewPrintItemButton,
    SvgIcon,
  },
  data() {
    return {
      orderProcess: orderProcess,
    };
  },
  computed: {
    ...mapGetters(["allCartItems"]),
    currentOrderProcessStep: {
      get() {
        return this.$store.getters["currentOrderProcessStep"];
      },
      set(orderProcessStep) {
        this.$store.dispatch("setCurrentOrderProcessStep", orderProcessStep);
      },
    },
    currentComponent() {
      switch (this.currentOrderProcessStep) {
        case this.orderProcess.STEPS.FILE_UPLOAD:
          return "FileUpload";
        case this.orderProcess.STEPS.CONFIGURE_MODEL:
          return "Configure3DModel";
        case this.orderProcess.STEPS.VIEW_CART:
          return "CartItemList";
        default:
          return "FileUpload";
      }
    },
    currentTransition() {
      if (this.currentComponent === "FileUpload") {
        return "fade";
      }
      return "slide-left";
    },
    route() {
      return this.$route.path;
    },
  },
  methods: {
    goToCart() {
      this.$store.dispatch("setCheckoutVisibility", false);
      this.$router.push("/payment-details");
    },
  },
};
</script>

<style></style>
